module.exports = __webpack_public_path__ + "img/Herz.a998bb3d.svg";